import styled from "styled-components";

export const CardContainer = styled.div`
	position: relative;
	display: flex;
	margin: 20px;
	width: 92%;
	border-radius: 8px;
	background-color: #FAFBFC;
	height: fit-content;
	min-height: 130px;
	padding: 20px;
	/* box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.06); */
    filter: drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.4));
	cursor: pointer;

	@media screen and (min-width: 1000px) {
		width: 98%;
	}

	@media screen and (min-width: 750px) {
		width: 97%;
	}

	@media screen and (max-width: 426px) {
		display: flex;
		width: 90%;
	}
`;

export const ImageContainer = styled.div`
	height: 100%;
	/* max-height: 500px; */
	max-height: 180px;
	width: 45%;
	display: flex;
	justify-content: end;
	transition: all 0.2s ease-in-out;
	margin-left: 10px;
	filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.4));

	@media screen and (max-width: 426px) {
		/* margin: 0px 0px 10px 0px; */
		display: flex;
		align-self: flex-start;
	}
`;

export const ImagePizza = styled.img`
	width: 100%;
	border-radius: 8px;
	min-height: 100px;
	max-height: 150px;
	min-width: 100px;
	max-width: 150px;

	@media screen and (max-width: 1000px) {
		width: 90%;
	}

	@media screen and (max-width: 600px) {
		width: 100%;
	}

	@media screen and (max-width: 426px) {
		min-height: unset;
		max-height: unset;
		min-width: unset;
		max-width: unset;
		/* height: 170px; */
		height: 150px;
		margin-left: 10px;
		width: 100%;
	}
`;

export const PizzaInformation = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	font-size: 14px;

	@media screen and (max-width: 426px) {
		width: 55%;
	}

	&.full-width {
		width: 100% !important;
	}
`;

export const PizzaName = styled.span`
	font-size: 16px;
	font-weight: 400;
	color: #333;
`;

export const PizzaIngredients = styled.span`
	color: #333;
	font-weight: 300;
	margin-bottom: 20px;
	width: 95%;
	font-size: 14px;
	margin-top: 5px;
`;

export const PizzaPrice = styled.span`
	color: #9B2424;
	position: absolute;
	bottom: 10px;
`;
